import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { IParamsGetUser, IUser } from '~/utils/interface/user';
import { handleGetUserList } from './userThunk';
import { SortDirectionEnum } from '~/utils/enum';

export interface UserState {
  users: Array<IUser>;
  filter: IParamsGetUser;
  totalItems: number;
  needRefreshData: boolean;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

const initialState: UserState = {
  users: [],
  totalItems: 0,
  needRefreshData: false,
  filter: {
    username: '',
    search: '',
    searchBy: '',
    startDate: '',
    endDate: '',
    roleid: undefined,
    active: undefined,
    sortBy: '',
    sortOrder: SortDirectionEnum.ASC,
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
  },
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsGetUser>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetUserList.pending, (_state, _action) => {})
      .addCase(handleGetUserList.fulfilled, (state, action) => {
        const data = action.payload?.result?.data;
        state.users = Array.isArray(data) ? data : [];
        state.totalItems = action.payload.result.total_record || 0;
        state.needRefreshData = false;
      })
      .addCase(handleGetUserList.rejected, (_state, _action) => {});
  },
});

export const userActions = userSlice.actions;

const userReducer = userSlice.reducer;
export default userReducer;
